<template>

  <v-container fluid class="px-10 pb-8 route-order-info" v-if="route">
    <v-row>
      <v-col>
        <span class="title">Assigned to Route</span>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <span class="pr-4 attr-label">Route name:</span>
        <span class="route-name">{{ route.name }}</span>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <span class="pr-4 attr-label">Route status:</span>
        <span>
          <v-chip label outlined :class="route.route_status">{{ route.route_status }}</v-chip>
        </span>
      </v-col>
    </v-row>
    <v-row class="mt-6">
      <v-col cols="12" xs="12" sm="12" md="3" lg="2">
        <router-link :to="generateRouteInfoPageLink()">
          View Route Info
        </router-link>
      </v-col>
      <v-col cols="12" xs="12" sm="12" md="3" lg="3">
        <router-link :to="generateDeliveryPageLink()" v-if="!isRouteCanceled">
          View Delivery
        </router-link>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
export default {
  name: 'RouteOrderInfo',

  props: {
    route: {
      type: Object
    }
  },

  computed: {
    isRouteCanceled () {
      return this.route.route_status === 'CANCELED'
    }
  },

  methods: {
    // Generate link data for the route info page
    generateRouteInfoPageLink () {
      return {
        name: 'route-info-overview',
        params: { routeId: this.route.id }
      }
    },

    // Generate link data for the delivery page
    generateDeliveryPageLink () {
      return {
        name: 'delivery-stepper',
        params: { routeId: this.route.id }
      }
    }
  }
}
</script>

<style scoped>
  .route-order-info .attr-label {
    color: #9e9e9e;
  }

  .route-order-info .route-name {
    font-size: 1.2rem;
  }

  .route-order-info a {
    text-decoration: none;
  }
  .route-order-info a:hover {
    text-decoration: underline;
  }
</style>
